import React from 'react'
import { View, Text, Image, ScrollView, Dimensions, Platform } from 'react-native'
import { styles } from './styles'
import Colors from '../../../constants/Colors';
import CS from '../../../constants/Styles';
import Button from '../../../components/Button';
import * as RootNavigation from '../../../utils/RootNavigation';
import { useLinkTo } from '@react-navigation/native';

export const Dispute = ({item, ...props }) => {

  const [imgWebStyle, setImgWebStyle] = React.useState({});

  const windowWidth = Dimensions.get('window').width;
  const linkTo = useLinkTo();
  // const { title } = props;

  React.useEffect(() => {
    setImgWebStyle(imgStyle(windowWidth));
    if (Platform.OS === 'web') {
      const subscription = Dimensions.addEventListener('change', onChangeDimensions);
      return () => {
        subscription.remove();
        // Dimensions.removeEventListener('change', onChangeDimensions);
      }
    }
  }, []);

  const goTo = () => {
    console.log('Go to ', item.goTo, props.agreementId);
    linkTo(`/dispute/${props.agreementId}/questions?initial=yes`);
  }

  const onChangeDimensions = ({ window, screen }) => {
    console.log('onChangeDimensions');
    setImgWebStyle(imgStyle(window.width));
  };

  const imgStyle = (windowWidth) => {
    if (Platform.OS === 'web') {
      const ratio = 720 / 1000;
      const width = windowWidth >= 768 ? 768 : windowWidth;
      return {
        width: width,
        height: width * ratio,
      }
    }
    return {};
  }

  const innerContent = () => {
    return(
      <>
        {item.intro.map((t, i) => {
          return <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]} key={i}>{t}</Text>
        })}
        <Image style={[CS.responsiveImage, styles.img, imgWebStyle]} source={item.image} />
        <Text style={[CS.smallTitle, CS.lightText]}>{item.number}. {item.title}</Text>
        {item.description.map((t, i) => {
          return <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]} key={i}>{t}</Text>
        })}
        {(item.button && props.agreementId) &&
          <Button text={item.button} onPress={() => goTo} style={styles.button} />
        }
      </>
    )
  }

  const outerContent = () => {
    if (Platform.OS === 'web') {
      return (
        <View style={styles.disputeView}>
          {innerContent()}
        </View>
      );
    } else {
      return (
        <ScrollView style={styles.dispute}>
          {innerContent()}
        </ScrollView>
      );
    }
  }

  // return (
  //   <View style={styles.dispute}>
  //     {props.intro.map((t, i) => {
  //       return <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]} key={i}>{t}</Text>
  //     })}
  //     <Image style={[CS.responsiveImage, styles.img]} source={props.image} />
  //     <Text style={[CS.smallTitle, CS.lightText]}>{props.number}. {props.title}</Text>
  //     {props.description.map((t, i) => {
  //       return <Text style={[CS.smallText, CS.lightBlueText, styles.paragraph]} key={i}>{t}</Text>
  //     })}
  //     {props.button && 
  //     <Button text={props.button} onPress={() => goTo} style={styles.button} />
  //     }
  //   </View>
  // );
  // return (
  //   <ScrollView style={styles.dispute}>
  //     {innerContent()}
  //   </ScrollView>
  // );

  return outerContent();
}

export default Dispute;